<template>
    <b-container>
        <div aria-live="polite" aria-atomic="true" style="position: relative;">
            <div class="toast" data-autohide="false"
                 style="position: absolute; top: 0px; right: 0; background-color: #BEBEBE; min-width: 25%;">
                <div class="toast-header">
                    <strong class="mr-auto">Ολοκλήρωση ενέργειας</strong>
                    <button type="button" class="close" data-dismiss="toast" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="toast-body">
                    {{ message_toast }}
                </div>
            </div>
        </div>

        <h2>{{ title }}</h2>
        <br>
        <router-link v-if="isMe" to="/register-me"><input type="button" class="btn btn-outline-success"
                                              value="Δημιουργία Διαχειριστή ΜΕ"/></router-link>
        <router-link v-else-if="isDeps" to="/register-sxhmatismos"><input type="button" class="btn btn-outline-success"
                                              value="Δημιουργία Διαχειριστή Σχηματισμού"/></router-link>
        <router-link v-else to="/register-des"><input type="button" class="btn btn-outline-success"
                                              value="Δημιουργία Διαχειριστή Διεύθυνσης Επιστρατεύσεως"/></router-link>
        <br>
        <br>

        <div class="form-group has-search">
            <span class="fa fa-search form-control-feedback"></span>
            <input type="text" id="search_string" class="form-control" style="float: left; width: 25%;"
                   v-on:keyup="search" placeholder="Αναζήτηση με βάση το Επώνυμο">
        </div>

        <br>
        <br>

        <table class="table table-hover table-bordered" id="table" data-toggle="table" data-sortable="true"
               data-sort-class="table-active">
            <thead>
            <tr>
                <!--                <th></th>-->
                <th data-field="aa" data-sortable="true">
                    <div class="th-inner sortable both">A/A</div>
                    <div class="fht-cell">

                    </div>
                </th>
                <th data-field="name" data-sortable="true">
                    <div class="th-inner sortable both">Όνομα</div>
                    <div class="fht-cell">

                    </div>
                </th>
                <th data-field="name" data-sortable="true">
                    <div class="th-inner sortable both">Επώνυμο</div>
                    <div class="fht-cell">

                    </div>
                </th>
                <th data-field="email" data-sortable="true">
                    <div class="th-inner sortable both">E-mail</div>
                    <div class="fht-cell">

                    </div>
                </th>
                <th data-field="afm" data-sortable="true">
                    <div class="th-inner sortable both">Α.Φ.Μ.</div>
                    <div class="fht-cell">

                    </div>
                </th>
                <th data-field="asm" data-sortable="true">
                    <div class="th-inner sortable both">Α.Μ.</div>
                    <div class="fht-cell">

                    </div>
                </th>
                <th data-field="telephone" data-sortable="true">
                    <div class="th-inner sortable both">Τηλέφωνο</div>
                    <div class="fht-cell">

                    </div>
                </th>
                <th v-if="isMe" data-field="telephone" data-sortable="true">
                  <div class="th-inner sortable both">Μονάδα παρακολ.</div>
                  <div class="fht-cell">

                  </div>
                </th>
                <th v-if="isDeps" data-field="telephone" data-sortable="true">
                  <div class="th-inner sortable both">ΔΕΠΣ</div>
                  <div class="fht-cell">

                  </div>
                </th>
                <th data-field="status" data-sortable="true">
                    <div class="th-inner sortable both">Κατάσταση</div>
                    <div class="fht-cell">

                    </div>
                </th>
                <th data-field="actions">
                    <div class="th-inner sortable both">Ενέργειες</div>
                    <div class="fht-cell">

                    </div>
                </th>
            </tr>
            </thead>

            <tbody>
            <tr id="sth" v-for="(manager,index) in managers" v-bind:key=index>
                <!--                <td>-->
                <!--                    <input :id="index" :value="index" :name="manager.moniEpwnymo" type="checkbox" v-model="checkedboxes" :checked="checked(manager)"/>-->
                <!--                </td>-->
                <td>{{ index + 1 }}</td>
                <td id="name">{{ manager.moniOnoma }}</td>
                <td id="lastname">{{ manager.moniEpwnymo }}</td>
                <td id="email">{{ manager.email }}</td>
                <td id="afm">{{ manager.atomMoniAfm }}</td>
                <td id="asm">{{ manager.strkProsKwd }}</td>
                <td id="tel">{{ manager.thlefwnoErgasias }}</td>
                <td v-if="isMe" id="monada">{{ manager.adiavMeeMona.monaLek }}</td>
                <td v-if="isDeps" id="monada">{{ manager.deps }}</td>
                <td v-if=(!manager.blocked) id="statusEnable">Ενεργοποιημένος</td>
                <td v-if=(manager.blocked) id="statusDisable">Απενεργοποιημένος</td>

                <td>
                    <div>
                        <button v-if="!manager.blocked" type="button" class="btn btn-danger btn-rounded btn-sm"
                                v-on:click.prevent="disableModal(manager)" style="margin:5px;">Απενεργοποίηση
                        </button>
                        <button v-if="manager.blocked" type="button" class="btn btn-success btn-rounded btn-sm"
                                v-on:click.prevent="enableModal(manager)" style="margin:5px;">Ενεργοποίηση
                        </button>
                        <button type="button" class="btn btn-warning btn-rounded btn-sm"
                                v-on:click.prevent="editModal(manager)" style="margin:5px;">Επεξεργασία
                        </button>
                    </div>
                </td>
            </tr>
            </tbody>
        </table>
        <!-- Modal for disable data-->
        <div class="modal fade" id="disable_modal" tabindex="-1" role="dialog" aria-labelledby="changeModal"
             aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="modal-disable-header">{{ modal_disable_header }}</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        {{ modal_disable_body }}
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Κλείσιμο</button>
                        <button type="button" class="btn btn-primary" v-on:click.prevent="disable">Απενεργοποίηση
                        </button>
                    </div>
                </div>
            </div>
        </div>


        <!-- Modal for enable admin-->
        <div class="modal fade" id="enable_modal" tabindex="-1" role="dialog" aria-labelledby="changeModal"
             aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="modal-enable-header">{{ modal_enable_header }}</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        {{ modal_enable_body }}
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Κλείσιμο</button>
                        <button type="button" class="btn btn-primary" v-on:click.prevent="enable">Ενεργοποίηση</button>
                    </div>
                </div>
            </div>
        </div>

        <div>
            <b-modal id="edit_modal" title="Στοιχεία Διαχειριστή" size="l" @ok="edit">
                <b-form @submit.stop.prevent>
                    <b-form-group label="Επώνυμο:">
                        <b-form-input v-model="selectedAdmin.moniEpwnymo" trim disabled></b-form-input>
                    </b-form-group>
                    <b-form-group label="Όνομα:">
                        <b-form-input v-model="selectedAdmin.moniOnoma" trim disabled></b-form-input>
                    </b-form-group>
                    <b-form-group label="Α.Μ.:">
                        <b-form-input v-model="selectedAdmin.strkProsKwd" trim disabled></b-form-input>
                    </b-form-group>
                    <b-form-group v-if="isMe" label="Παρακολ. Μονάδα: " label-align="left">
                        <b-form-select v-model="selectedAdmin.adiavMeeMona"
                                       :options="me_items"></b-form-select>
                    </b-form-group>
                    <b-form-group label="E-mail:" label-align="left">
                        <b-form-input v-model="selectedAdmin.email" trim></b-form-input>
                    </b-form-group>
                </b-form>
            </b-modal>
        </div>
    </b-container>
</template>

<script>
import {HTTP} from '../main.js';
import {Structs} from "../structs";

export default {
    name: "ShowAdmins",
    props: {
        isMe: Boolean,
        title: String,
        isDeps: Boolean
    },
    data: function () {
        return {
            modal_enable_header: "",
            message_toast: "",
            modal_enable_body: "",
            modal_disable_header: "",
            modal_disable_body: "",
            tbldata: [],
            checkedboxes: [],
            managers: [],
            selectedAdmin: {},
            me_items: [],
        };
    },

    created() {
        if (!this.$store.getters.isAdmin) this.$router.push('/');
    },

    mounted() {
        this.getAdmins();
    },

    methods: {
        getAdmins: function () {
            this.$store.dispatch('loading');
            let url;
            if (this.isMe) {
                url = "/manager"
            } else if(this.isDeps) {
                url = "/manager/deps"
            } else {
                url = "/admin"
            }
            HTTP.get(url)
                .then((response) => {
                    var resp = response.data;
                    let data = resp.responseData;
                    for (let i = 0; i < data.length; i++) {
                        this.managers.push(data[i]);
                    }
                })
                .catch((e) => {
                    console.error(e);
                    this.$router.push({'name': 'login'});
                })
                .finally(() => this.$store.dispatch('stop_loading'));
        },

        search: function () {

            var input, filter, table, tr, name, i, txtValue;
            input = document.getElementById("search_string");
            filter = input.value.toUpperCase();
            table = document.getElementById("table");
            tr = table.getElementsByTagName("tr");

            for (i = 0; i < tr.length; i++) {
                name = tr[i].getElementsByTagName("td")[2];
                if (name) {
                    txtValue = name.textContent || name.innerText;
                    if (txtValue.toUpperCase().indexOf(filter) > -1) {
                        tr[i].style.display = "";
                    } else {
                        tr[i].style.display = "none";
                    }
                }
            }
        },
        disableModal: function (item) {
            this.selectedAdmin = item
            this.modal_disable_header = "Απενεργοποίηση του Διαχειριστή με ΑΦΜ: " + item.atomMoniAfm;
            this.modal_disable_body = "Παρακαλούμε επιβεβαιώστε την απενεργοποίηση του χρήστη με Α.Φ.Μ.: " + item.atomMoniAfm + " και Α.Μ.: " + item.strkProsKwd + ".";
          $('#disable_modal').modal('show');
        },

        enableModal: function (item) {
            this.selectedAdmin = item
            this.modal_enable_header = "Ενεργοποίηση του Διαχειριστή με ΑΦΜ: " + item.atomMoniAfm;
            this.modal_enable_body = "Παρακαλούμε επιβεβαιώστε την ενεργοποίηση του χρήστη με ΑΦΜ: " + item.atomMoniAfm + " και Α.Μ.: " + item.strkProsKwd + ".";
          $('#enable_modal').modal('show');
        },

        editModal: function (item) {
            this.selectedAdmin = item
            this.$bvModal.show('edit_modal');
        },

        disable: function () {
            let item = this.selectedAdmin
            let afm = item.atomMoniAfm;

            let body = {
                'afm': afm
            };
            this.$store.dispatch('loading')
            HTTP.post("/authorization/users/deactivate", body).then((response) => {
                var resp = response.data;

                $('#disable_modal').modal('hide');

                if (resp.message) {
                    this.message_toast = resp.message;
                    $('.toast').toast('show');
                }
                item.blocked = true;
            }).catch((e) => {
                console.error(e);
                var resp = e.response;
                let message;
                message = (resp.data.errorMessage) ? resp.data.errorMessage : resp.statusText;
                if (message === "") {
                    message = "Υπήρξε κάποιο πρόβλημα!"
                }
                this.message_toast = message;
                $('.toast').toast('show');
                $('#disable_modal').modal('hide');
            }).finally(() => {
                this.$store.dispatch('stop_loading');
            });
        },

        edit: function () {
            let item = Structs.Admin()
            item.strkProsKwd = this.selectedAdmin.strkProsKwd;
            item.email = this.selectedAdmin.email;
            item.parakolMonada = this.selectedAdmin.adiavMeeMona;

            this.show_error = false;
            if (item.email === '') {
                this.message_toast = "Παρακαλώ εισάγετε ένα έγκυρο E-mail.";
                $('.toast').toast('show');
                return
            }

            let url;
            if (this.isMe) {
                if (item.parakolMonada.efEaPinakaE === '') {
                    this.message_toast = "Παρακαλώ εισάγετε μία έγκυρη μονάδα.";
                    $('.toast').toast('show');
                    return
                }
                url = "/manager/edit"
            } else if(this.isDeps) {
                url = "/manager/edit";
                item.deps = this.selectedAdmin.deps;
                item.depsKwd = this.selectedAdmin.depsKwd;
            } else 
                url = "/admin/edit"

            this.$store.dispatch("loading")
            HTTP.post(url, item)
                .then((response) => {
                    var resp = response.data;
                    this.message_toast = "Η επεξεργασία ήταν επιτυχής";
                    $('.toast').toast('show');
                }).catch((e) => {
                console.error(e);
                if (e.response.data.errorMessage) {
                    this.message_toast = e.response.data.errorMessage
                } else {
                    this.message_toast = 'Υπήρξε κάποιο πρόβλημα κατά την επεξεργασία του Διαχειριστή.'
                }
                $('.toast').toast('show');
            }).finally(() => this.$store.dispatch("stop_loading"));
        },

        enable: function () {
            let item = this.selectedAdmin
            let afm = item.atomMoniAfm;

            let body = {
                'afm': afm
            };
            this.$store.dispatch('loading')
            HTTP.post("/authorization/users/activate", body).then((response) => {
                var resp = response.data;

                $('#enable_modal').modal('hide');

                if (resp.message) {
                    this.message_toast = resp.message;
                    $('.toast').toast('show');
                }

            }).catch((e) => {
                console.error(e);
            }).finally(() => {
                this.$store.dispatch('stop_loading');
                item.blocked = false;
            });
        }
    }
}
</script>

<style scoped>
.btn {
    margin-left: 4px;
    margin-right: 4px;
}

.btn-change {
    font-size: 13px;
    color: #007bff;
    letter-spacing: 1px;
    line-height: 15px;
    border: 2px solid rgba(58, 133, 191, 0.75);
    border-radius: 8px;
    background: transparent;
    transition: all 0.3s ease 0s;
}

.btn-change:hover {
    color: #FFF;
    background: #007bff;
    border: 2px solid rgba(58, 133, 191, 0.75);
}


.btn-danger {
    font-size: 13px;
    color: #dc3545;
    letter-spacing: 1px;
    line-height: 15px;
    border: 2px solid rgba(217, 83, 78, 0.75);
    border-radius: 8px;
    background: transparent;
    transition: all 0.3s ease 0s;
}

.btn-warning:focus:not(:hover) {
    color: #ffc107;
    background: transparent;
    outline: 0;
    box-shadow: unset;
}

.btn-warning {
    font-size: 13px;
    color: #ffc107;
    letter-spacing: 1px;
    line-height: 15px;
    border: 2px solid #ffc107;
    border-radius: 8px;
    background: transparent;
    transition: all 0.3s ease 0s;
}

.btn-danger:hover {
    color: #FFF;
    background: #dc3545;
    border: 2px solid rgba(217, 83, 78, 0.75);
}

.btn-success {
    font-size: 13px;
    color: #28a745;
    border-color: #28a745;
    letter-spacing: 1px;
    line-height: 15px;
    border-radius: 8px;
    background: transparent;
    transition: all 0.3s ease 0s;
}

.btn-success:hover {
    color: #FFF;
    background: #28a745;
    border-color: #28a745;
}

.has-search .form-control {
    padding-left: 2.375rem;
}

.has-search .form-control-feedback {
    position: absolute;
    z-index: 2;
    display: block;
    width: 2.375rem;
    height: 2.375rem;
    line-height: 2.375rem;
    text-align: center;
    pointer-events: none;
    color: #aaa;
}
</style>
